export default function Logo() {
    return (
        <svg className='svg-icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg'>
            <path d='M544.928 138.464l256 157.984A66.24 66.24 0 0 1 832 352.896V673.28a66.24 66.24 0 0 1-31.072 56.448l-256 157.984c-20.256 12.48-45.6 12.48-65.856 0l-256-157.984A66.24 66.24 0 0 1 192 673.28V352.896c0-23.136 11.808-44.544 31.072-56.448l256-157.984a62.496 62.496 0 0 1 65.856 0z m220.8 258.912l-220.608 136.16v272.288l220.64-136.16-0.032-272.288z m-507.488 6.944v265.344l209.376 129.216v-265.344L258.24 404.32z m254.336-204.416l-226.848 139.968 221.184 136.48 226.816-139.968-221.152-136.48z' />
        </svg>

    )
};